import { DSDealButton } from 'shared-definitions/types'
import { ApiDealShortProps } from 'data-source/types.wp'
import { oneDealPriceMapper } from 'data-source/mappers/oneDealPriceMapper'
import { retailerButtonTitleMapper } from 'data-source/mappers/retailerButtonTitleMapper'
import { pLinkMapper, PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

export function dealsButtonMapper(input: ApiDealShortProps, opts: PLinkMapperOpts): DSDealButton {
  return {
    link: {
      label: retailerButtonTitleMapper(input.retailer.name, input),
      pLink: pLinkMapper(input.retailer.url, opts),
    },
    price: oneDealPriceMapper(input),
  }
}
